import Vue from 'vue'
// import VueResource from 'vue-resource'
// import VueLazyLoad from 'vue-lazyload'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
// import VueCarousel from 'vue-carousel'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
// import 'swiper/css/swiper.css'
// // If you use Swiper 6.0.0 or higher
// import 'swiper/swiper-bundle.css'
// import "@babel/polyfill";
// import VueSweetalert2 from 'vue-sweetalert2';


import '@/assets/css/spice.css';

import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-70338709-1" }
});


import route from './route.vue'

Vue.config.performance = true;

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    }
    window.addEventListener('scroll', f);
  }
});
Vue.use(VueTinyLazyloadImg);
// Vue.use(VueLazyLoad, {
//   preLoad: 1.3,
//   error: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAW0AAADNCAYAAABzaiF4AAACL0lEQVR42u3UQREAAAQAMCoIoIH+9XTwc7eFWE5UBwAvpLQBpA2AtAGkLW0AaQMgbQBpAyBtAKQNIG0ApA2AtAGkDYC0AZA2gLQBkDYA0gaQNgDSBkDaANIGQNoASBtA2gBIGwBpA0gbAGkDIG0AaQMgbQCkDSBtAKQNgLQBpA2AtAGQNoC0AZA2ANIGkDYA0gZA2gDSBkDaAEgbQNoASBsAaQNIGwBpAyBtAGkDIG0ApA0gbQCkDYC0AaQNgLQBkDaAtAGQNgDSBpA2ANIGQNoA0gZA2gBIG0DaAEgbAGkDSBsAaQMgbQBpAyBtAKQNIG0ApA2AtAGkDYC0AaQtbQBpAyBtAGlLG0DaAEgbQNoASBsAaQNIGwBpAyBtAGkDIG0ApA0gbQCkDYC0AaQNgLQBkDaAtAGQNgDSBpA2ANIGQNoA0gZA2gBIG0DaAEgbAGkDSBsAaQMgbQBpAyBtAKQNIG0ApA2AtAGkDYC0AZA2gLQBkDYA0gaQNgDSBkDaANIGQNoASBtA2gBIGwBpA0gbAGkDIG0AaQMgbQCkDSBtAKQNgLQBpA2AtAGQNoC0AZA2ANIGkDYA0gZA2gDSBkDaAEgbQNoASBsAaQNIGwBpAyBtAGkDIG0AaUsbQNoASBtA2tIGkDYA0gaQNgDSBkDaANIGQNoASBtA2gBIGwBpA0gbAGkDIG0AaQMgbQCkDSBtAKQNgLQBpA2AtAGQNoC0AZA2ANIGkDYA0gbgZAGQr0tHZdTsuwAAAABJRU5ErkJggg==',
//   loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAW0AAADNCAYAAABzaiF4AAACLUlEQVR42u3UQQ0AAAgEoLOIDexfzw7+3CAElUwHgBdK2gDSBkDaANKWNoC0AZA2gLQBkDYA0gaQNgDSBkDaANIGQNoASBtA2gBIGwBpA0gbAGkDIG0AaQMgbQCkDSBtAKQNgLQBpA2AtAGQNoC0AZA2ANIGkDYA0gZA2gDSBkDaAEgbQNoASBsAaQNIGwBpAyBtAGkDIG0ApA0gbQCkDYC0AaQNgLQBkDaAtAGQNgDSBpA2ANIGQNoA0gZA2gBIG0DaAEgbAGkDSBsAaQMgbQBpAyBtAKQNIG0ApA2AtAGkDYC0AZA2gLQBkDYA0gaQNgDSBkDaANIGQNoA0pY2gLQBkDaAtKUNIG0ApA0gbQCkDYC0AaQNgLQBkDaAtAGQNgDSBpA2ANIGQNoA0gZA2gBIG0DaAEgbAGkDSBsAaQMgbQBpAyBtAKQNIG0ApA2AtAGkDYC0AZA2gLQBkDYA0gaQNgDSBkDaANIGQNoASBtA2gBIGwBpA0gbAGkDIG0AaQMgbQCkDSBtAKQNgLQBpA2AtAGQNoC0AZA2ANIGkDYA0gZA2gDSBkDaAEgbQNoASBsAaQNIGwBpAyBtAGkDIG0ApA0gbQCkDYC0AaQNgLQBkDaAtAGQNoC0pQ0gbQCkDSBtaQNIGwBpA0gbAGkDIG0AaQMgbQCkDSBtAKQNgLQBpA2AtAGQNoC0AZA2ANIGkDYA0gZA2gDSBkDaAEgbQNoASBsAaQNIGwBpA3Cyk+g83f23qMwAAAAASUVORK5CYII=',
//   attempt: 3
// });


new Vue({
  render: h => h(route)
}).$mount('#route')

